import React from "react";
import PropTypes from "prop-types";
import styles from "./bigScreen.less";

function MetaModel(props) {
  const { model, getLangMsg, data } = props
  const { 
    Property = 0, // 属性
    Element = 0, // 元素
    ModelType = 0, // 单据类型
    Operator = 0, // 操作
    Rule = 0, // 规则,
    Service = 0, // 服务
    Validator = 0, //校验器
 } = data || {}
  return (
    <div className={styles.metaModel}>
      <div className={styles.metaModelWrapper}>
        <div className={styles.itemContainer}>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{ModelType}</div>
            {/* <div className={styles.itemText}>单据类型</div> */}
            <div className={styles.itemText}>{getLangMsg('metaModel.key0001')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Element}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0002')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Property}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0003')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Rule}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0004')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Validator}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0005')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Service}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0006')}</div>
          </div>
          <div className={styles.itemDetails}>
            <div className={styles.itemNumber}>{Operator}</div>
            <div className={styles.itemText}>{getLangMsg('metaModel.key0007')}</div>
          </div>
        </div>
        <div className={styles.metaModelBase}></div>
        <div className={styles.commonTemplateTitle}>
          <div className={styles.titleLeftIcon}></div>
          <div className={styles.titleText}>{getLangMsg('metaModel.key0008')}</div>
          <div className={styles.titleRightIcon}></div>
        </div>
      </div>
    </div>
  );
}
MetaModel.propTypes = {
  baseinfo: PropTypes.object,
  name: PropTypes.string,
};
export default MetaModel;
